module.exports = {"TXTCLI_Available":{"id":"TXTCLI_Available","defaultMessage":"Saadaval"},"TXTCLI_Expires":{"id":"TXTCLI_Expires","defaultMessage":"Aegub"}}